export default {
    todo: {
        unit: {
            title      : "ANLAGEN<br>TOTAL",
            digitilized: "Davon digitalisiert:",
            bounced    : "Abgelehnte Mails:",
            lim: {
                terminated: "LM abgelaufen"
            }
        },
        filter: {
            customer: "Kunde"
        },
        delay: {
            title: "Überfällige ZÜS Prüfungen"
        },
        sitedown: {
            title: "Stehende Anlagen"
        },
        missing: {
            title: "Fehlende Daten"
        },
        open: {
            title: "Offene Ereignisse"
        },
        invoices: {
            title: "Offene Rechnungen"
        },

        maintenance: {
            title: "Offene Wartungen"
        },

        guard: {
            imported: {
                title: "Neu importiert",
            },
            open: {
                title: "Offene Aufzugswärter Prüfungen",
                title2: "Offene Prüfungen"
            },
            failed: {
                title: "Fehlerhaft importiert",
                title2: "Fehlerhaft importierte Aufzugswärter Protokolle"
            },

            assign: {
                title: "Anlage zuordnen",
                label: "Ereignis erstellen",
                text : "Mit Ereignis erstellen wird die gewählte Anlage dem Aufzugswärter Protokoll zugeordnet und ein entsprechndes Ereignis generiert.",
                success: "Die Anlage wurde dem Aufzugswärter Protokoll zugeordnet"
            },

            delete: {
                query: "Soll das Protokoll gelöscht werden?",
                text : "Mit <b>JA</b> wird das Aufzugswärter Protokoll gelöscht. Eine weitere Bearbeitung ist dann nicht mehr möglich. Soll die Löschung nun durchgeführt werden?",
                success: "Das Aufzugswärter Protokoll wurde gelöscht"
            }
        },

        lgs: {
            title: "LiftGuardian",
            STANDSTILL: {
                title: "Stillstände",
            },
            LONG_STANDSTILL: {
                title: "Stillstände > 1 Tag",
            },
            UNKNOWN: {
                title: "Unbekannt"
            },
            RECENTLY_RECOVERED: {
                title: "Anlage wieder aktiv"
            },
            resolved   : {
                title: "Anlage wieder aktiv",
                hint : "(letzte 7 Tage)"
            },
            type: {
                STANDSTILL     : "Stillstand",
                LONG_STANDSTILL: "Stillstand > 1 Tag",
                UNKNOWN        : "Unbekannt",
                NORMAL         : "Wieder aktiv"
            }
        },

        assessment: {
            maintitle: "Offene ZÜS Prüfungen",
            title: {
                minor   : "Geringfügige Mängel",
                middle  : "Erhebliche Mängel",
                major   : "Gefährliche Mängel",
                canceled: "Prüfung abgebrochen",
            },
            label: {
                minor   : "Geringfügig",
                middle  : "Erheblich",
                major   : "Gefährlich",
            },
            prio: {
                none  : "ohne Angabe einer First",
                label : "Frist läuft ab ...",
                high  : "innerhalb der nächsten 2 Wochen",
                middle: "innerhalb der nächsten 4 Wochen",
                low   : "nach 4 Wochen"
            }
        },
        bounced: {
            title: "Abgelehnte Mails",
        }
    }
}